import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
// 非遗定制弹窗  数据对接非遗项目
import { handleHttp, loadScript, locationHandlev2, setImgsize, getImg } from "@/utils/utils";
import QRCode from 'qrcodejs2';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  name: 'comp5app',
  data() {
    return {
      person: [],
      timer: null,
      linkcontainerflag: false,
      iframeurl: '',
      routeflag: false,
      popLeftIndex: 0,
      popLeftArr: [{
        name: '简介',
        id: 0,
        flag: true
      }, {
        name: '传承人',
        id: 1,
        flag: false
      }, {
        name: '图片',
        id: 2,
        flag: false
      }, {
        name: '视频',
        id: 3,
        flag: false
      }, {
        name: '传习所',
        id: 4,
        flag: false
      }],
      picture: [],
      videoList: [],
      videoitem: {},
      playiconshow: true,
      ewmflag: false,
      seminarList: [],
      bigDialog: false,
      viewer: null
    };
  },
  components: {},
  watch: {
    '$attrs.popshowflag': {
      handler(val) {
        console.log(`$attrs.popshowflag`, val);
      },
      deep: true
    },
    '$attrs.detail': {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.$nextTick(() => {
            const dom = document.querySelector('.popcontainer-style1');
            if (dom === null) return;
            dom.style.position = 'fixed';
            dom.style.setProperty('left', `${val.pixel[0]}px`, 'important');
            dom.style.setProperty('top', `${val.pixel[1]}px`, 'important');
          });
        }
      },
      deep: true
    },
    '$attrs.detail.person': {
      handler(val) {
        if (val) {
          this.person = [];
          this.person = val;
          this.popLeftArr[1].flag = true;
        }
      },
      deep: true
    },
    '$attrs.detail.pictureList': {
      handler(val) {
        if (val) {
          this.picture = [];
          if (this.$route.query.fid === '138053') {
            val.forEach(elem => {
              this.picture.push(elem.itemformdata.img1[0]);
            });
          } else {
            val[0].itemformdata[1].forEach(elem => {
              if (elem.values && elem.values[0]) this.picture.push(getImg(elem.values[0][0]));
            });
          }
          this.popLeftArr[2].flag = true;
        }
      },
      deep: true
    },
    '$attrs.detail.videoList': {
      handler(val) {
        if (val) {
          this.popLeftArr[3].flag = true;
          this.videoList = [];
          if (this.$route.query.fid === '138053') {
            this.videoList = val[0].itemformdata.video;
            this.$api.getUrlByObjectId(val[0].itemformdata.video[0].objectId).then(res => {
              this.videoitem.url = res.http;
              this.videoitem.fileUrl = this.videoList[0].fileUrl;
            });
          } else {
            this.videoList = val[0].itemformdata[5];
            this.$api.getUrlByObjectId(val[0].itemformdata[5][0].objectId).then(res => {
              this.videoitem.url = res.http;
            });
          }
        }
      },
      deep: true
    },
    '$attrs.detail.seminarList': {
      handler(val) {
        if (val) {
          console.log(`this.seminarList`);
          console.log(val);
          this.seminarList = [];
          this.seminarList = val;
          this.popLeftArr[4].flag = true;
        }
      },
      deep: true
    },
    '$attrs.direction': {
      handler(val) {
        this.setScreenStyle(val);
      },
      deep: true
    }
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  mounted() {},
  methods: {
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.popLeftArr.forEach((elem, index) => {
        if (index > 0) elem.flag = false;
      });
      this.popLeftIndex = 0;
      this.picture = [];
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    getImg(val) {
      return setImgsize(val, 160, 228);
    },
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    openUrl(url) {
      window.open(url);
    },
    changevideo() {
      this.$refs.videoDom.play();
      this.playiconshow = false;
    },
    goLocation() {
      let details = {
        placeName: this.$attrs.detail.correlation_address[0].address,
        linkTarget: '否',
        open: true
      };
      locationHandlev2.call(this, details, {
        route: this.$attrs.detail.correlation_address
      });
      // this.linkcontainerflag = false
    },
    getCode() {
      this.ewmflag = true;
      this.$nextTick(() => {
        new QRCode(this.$refs['qrcode-share'], {
          text: this.$attrs.detail.detailUrl,
          // 扫二维码后获得的信息
          width: 200,
          // 图片宽90px，左右padding各4px，边框各1px， 100-8px-2px
          height: 200,
          // 图片高90px，上下padding各4px，边框各1px， 100-8px-2px
          correctLevel: 3
        });
      });
    },
    bigDialogClose() {
      this.popLeftArr.forEach((elem, index) => {
        if (index > 0) elem.flag = false;
      });
      this.popLeftIndex = 0;
      this.picture = [];
      this.bigDialog = false;
    },
    bigDialogOpen() {
      this.bigDialog = true;
      let that = this;
      this.$nextTick(() => {
        const pop4 = document.querySelector('.popcontainer-style4');
        pop4.style.width = `${window.innerWidth}px`;
        pop4.style.height = `${window.innerHeight}px`;
        let swipersmallEl = new Swiper(that.$refs.smallswiper, {
          initialSlide: 0,
          spaceBetween: 18,
          slidesPerView: 8,
          watchSlidesProgress: true,
          observeParents: true,
          observer: true
        });
        let swiperbigEl = new Swiper(that.$refs.bigswiper, {
          initialSlide: 0,
          // autoplay: true,
          observeSlideChildren: true,
          observeParents: true,
          observer: true,
          thumbs: {
            swiper: swipersmallEl
          }
        });
        this.$nextTick(() => {
          new Swiper(that.$refs.videosmallswiper, {
            initialSlide: 0,
            spaceBetween: 18,
            slidesPerView: 8,
            watchSlidesProgress: true,
            observeParents: true,
            observer: true
          });
        });
        this.initViewer();
      });
    },
    setScreenStyle(val) {
      let width = window.screen.width;
      let height = window.screen.height;
      const popiframe = document.querySelector('#popiframe');
      popiframe.style.width = (val ? height : width) + 'px';
      popiframe.style.height = (val ? width : height) + 'px';
      popiframe.style.transform = val ? `rotate(90deg) translate(${(height - width) / 2}px, ${(height - width) / 2}px)` : '';
    },
    setBigPicture(val) {
      return setImgsize(val, 800, 460);
    },
    setSmallPicture(val) {
      return setImgsize(val, 85, 105);
    },
    initViewer() {
      this.$nextTick(() => {
        if (this.viewer) {
          this.viewer.destroy();
          this.viewer = null;
          return;
        }
        let that = this;
        this.viewer = new Viewer(document.querySelector('#showBigswiper'), {
          navbar: true,
          // 显示导航栏
          toolbar: {
            prev: true,
            next: true
          },
          // 显示工具栏
          title: false,
          viewed() {
            if (document.body.clientWidth < document.body.clientHeight) {
              that.viewer.rotateTo(90);
            } else {
              that.viewer.rotateTo(0);
            }
            document.querySelector('.viewer-container').classList.add(`fid${that.$route.query.fid}mobile`);
          }
        });
      });
    }
  }
};